import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class DataTracControlNumberRange extends DexResourceModel {

    @Field(String)
    public companyNumber: string = "";

    @Field(Number)
    public rangeStart: number | null = 0;

    @Field(Number)
    public rangeEnd: number | null = 0;


    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
